import { initForm } from '../../utils/formHandler'

initForm({
  formSelector: '#custom-dedic-form',
  submitBtnSelector: '[data-custom-dedic-submit]',
  apiEndpoint: '/v1/api/form/b2b/custom-dedic',
  selectors: {
    name: '#custom-dedic-name',
    email: '#custom-dedic-email',
    phone: '#custom-dedic-phone',
  },
  fields: [
    {
      name: 'subject',
      selector: '#custom-dedic-subject-name',
      errorSelector: '#subject-msg',
      required: true,
      errorKey: 'enter_subject',
    },
  ],
})
